/**
 * Ensures that a thrown value is returned as an `Error` object.
 *
 * If the provided value is already an instance of `Error`, it is returned as-is.
 * Otherwise, attempts to stringify the value and wraps it in a new `Error` object,
 * indicating that a non-Error value was thrown.
 *
 * @param value - The value to ensure as an `Error`.
 * @returns An `Error` object representing the thrown value.
 */
export const ensureError = (value: unknown): Error => {
  if (value instanceof Error) {
    return value;
  }

  let stringified = '[Unable to stringify the thrown value]';

  try {
    stringified = JSON.stringify(value);
  } catch {
    // ignore
  }

  return new Error(`This value was thrown as is, not through an Error: ${stringified}`);
};
